/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { HeroImageSectionFront } from 'sarsaparilla';

export default class TripPlannerHero extends React.Component {
    render() {
        return (
            <HeroImageSectionFront
                title="Trip Builder"
                text="This is your vacation&#39;s blank canvas, the chance to chart your own course. Anything is possible, and
                the possibilities are endless! So, what are you waiting for?"
                backgroundImagePath="/img/trip-planner/hero/trip-planner-hero"
                backgroundImageAltText="A two lane highway down a long hillside"
                backgroundImageColorOverlay="#55698f"
                backgroundImageColorOverlayOpacity={0.4}
                className="mb-2"
            />
        );
    }
}
